<template>
    <div class="block-search2">
        <svg-icon icon-class="header_back" @click.native="$utils.back()"></svg-icon>
        <search-input type="block" :gray="gray" :placeholder="placeholder" :page-type="pageType"></search-input>
        <svg-icon icon-class="menu" @click.native="showMenuContent = !showMenuContent"></svg-icon>
        <slot></slot>
        <header-menus v-if="showMenuContent"></header-menus>
    </div>
</template>

<script>
import searchInput from "../searchInput.vue";
import svgIcon from "../svgIcon.vue";
import headerMenus from "../base/menu.vue";

export default {
    name: "block-search2",
    components: { searchInput, svgIcon, headerMenus },
    props: {
        gray: String,
        placeholder: String,
        pageType: String
    },
    data() {
        return {
            showMenuContent: false
        }
    }
}
</script>

<style lang="scss" scoped>
    .block-search2 {
        display: flex;
        align-items: center;
        padding: 4px 0;
        position: sticky;
        top: 0;
        background: white;
        z-index: 9;

        .header_back {
            margin-left: 6px;
            margin-right: 14px;
        }

        .block {
            flex: 1;
        }

        .menu {
            color: #0B0F23;
            width: 24px;
            height: 24px;
            margin-right: 12px;
            margin-left: 20px;
        }

        /deep/ .search-input {
            .input {
                border-radius: 18px;
                overflow: hidden;
            }
            .button {
                display: none;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/search2.vue